export const DocumentationTabsData = [
  {
    key: "gettingStarted",
    label: "Getting Started",
    title:
      "Welcome to your dashboard! This section will guide you through setting up your account, navigating the interface, and understanding key features.",
    keyPoints: [
      "Dashboard Navigation: Use the sidebar to access different sections like Notifications, Voicemail, Billing, and Security.",
      "Profile Setup: Update your profile information including email, phone number, and preferences for smoother communication.",
      "Email Verification: Ensure your email is verified to receive all alerts, notifications, and account updates without delay.",
      "Notification Preferences: Customize email and SMS notifications to get alerts for missed calls, system updates, and important account changes.",
    ],
    tips: [
      "Always keep your contact email updated to receive notifications.",
      "Use the “Need Help?” card to access guides anytime.",
      "Regularly check your notification settings to ensure you’re getting the right alerts.",
      "Keep your profile information accurate to avoid missed messages or alerts.",
    ],
    advice: [
      "Bookmark important documentation links for quick reference.",
      "Explore each dashboard section at least once to understand all features.",
    ],
  },
  {
    key: "smsEmail",
    label: "SMS & Email Notifications",
    title: "",
    // Content is rendered custom in DocTabs for this tab
  },
  {
    key: "voicemail",
    label: "Voicemail & Transcription",
    title:
      "Voicemail settings let you control how messages are delivered and transcribed.",
    keyPoints: [
      "Default Transcription Language: English (US)",
      "Include Caller ID in Email: Toggle ON to see who called directly in your email notification.",
      "Attach Audio File: Toggle ON to receive the actual voicemail audio along with the transcription.",
      "Auto-delete Audio after Delivery: Toggle ON/OFF based on your storage preference.",
    ],
    tips: [
      "Regularly review transcription accuracy for critical calls.",
      "Combine caller ID + attached audio for complete context.",
      "Adjust settings based on your daily workflow to avoid clutter.",
    ],
    advice: [
      "Listen to voicemail audios if transcription seems inaccurate.",
      "Forward important voicemails to email for backup.",
    ],
  },
  {
    key: "billing",
    label: "Billing & Plan Info",
    title: "Keep track of your subscription, payments, and plan benefits.",
    keyPoints: [
      "Current Plan: Shows your active subscription tier (Basic, Special, Premium, etc.).",
      "Next Billing Date: Displays the upcoming payment date.",
      "Payment Method: Shows the last 4 digits of the card used for payment.",
      "View Invoices: Access detailed invoices for past transactions.",
      "Upgrade Plan: Move to higher tiers to unlock additional features like unlimited SMS, email alerts, and storage.",
    ],
    tips: [
      "Keep your billing email updated to receive invoices and notifications.",
      "Review your plan periodically to ensure it fits your usage.",
      "Save invoices for accounting or reimbursement purposes.",
    ],
    advice: [],
  },
  {
    key: "security",
    label: "Security Settings",
    title:
      "Protect your account and ensure secure access to notifications and sensitive information.",
    keyPoints: [
      "Change Password: Update passwords regularly and use strong, unique combinations.",
      "Two-Factor Authentication (2FA): Enable for extra login security.",
      "Login Alerts: Get notified whenever your account is accessed from a new device.",
      "Active Sessions: View currently logged-in devices and logout remotely if needed.",
    ],
    tips: [
      "Always use the email registered to your account for 2FA alerts.",
      "Combining strong password + 2FA significantly increases security.",
      "Monitor login alerts to detect any unauthorized access early.",
    ],
    advice: [
      "Log out from shared devices to prevent account misuse.",
      "Regularly review security settings after updates or system changes.",
    ],
  },
  {
    key: "troubleshooting",
    label: "Troubleshooting",
    title:
      "Common issues related to notifications, emails, and voicemail are addressed here.",
    // Content is rendered custom in DocTabs for this tab
  },
];
